// src/help/help-center/types.ts
var HelpHelpCenterAriResourceOwner = "help", HelpHelpCenterAriResourceType = "help-center";

export {
  HelpHelpCenterAriResourceOwner,
  HelpHelpCenterAriResourceType
};
